import { render } from "./LoaderSpinner.vue?vue&type=template&id=47b0b088&scoped=true&ts=true"
import script from "./LoaderSpinner.vue?vue&type=script&lang=ts"
export * from "./LoaderSpinner.vue?vue&type=script&lang=ts"

import "./LoaderSpinner.vue?vue&type=style&index=0&id=47b0b088&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b0b088"]])

export default __exports__